import { ClientType } from './chat';

export interface Survey {
    title: string;
    intro: string;
    outro: string;
    questions: Question[];
    enabled: boolean;
    required: boolean;
    isValid: boolean;
    useDefault: boolean;
}

export interface SurveyWithPoints extends Survey {
    questions: QuestionWithPoints[];
}

export interface Exam {
    title: string;
    intro: string;
    outro: string;
    questions: Question[];
    enabled: boolean;
    required: boolean;
    isValid: boolean;
    allowRetries: boolean;
    maximumRetries: number;
    showResult: boolean;
    showWrongAnswers: boolean;
    passingScore: number;
    passed: string;
    failed: string;
}

export enum ExamResultType {
    NotAvailable,
    Passed,
    Failed
}

export interface ExamResult {
    result: ExamResultType;
    canRetry?: boolean;
    score?: number;
    passingScore?: number;
    wrongAnswers?: QuestionAnswer[];
}

export interface ExamWithPoints extends Exam {
    questions: QuestionWithPoints[];
}

export interface Question {
    questionId: string;
    questionText: string;
    questionType: QuestionType;
    options: QuestionOption[];
    hasOtherOption: boolean;
    otherOptionText?: string;
    required: boolean;
}

export interface QuestionWithPoints extends Question {
    options: QuestionOptionWithValues[];
}

export interface QuestionOption {
    optionId: string;
    text: string;
}

export interface QuestionOptionWithValues extends QuestionOption {
    value?: number;
}

export enum QuestionType {
    MultipleChoice,
    SingleChoice,
    Open
}

export enum QuestionStatus {
    Closed,
    ShowIntro,
    ShowQuestion,
    ShowOutro
}

export interface QuestionAnswer {
    participantId?: string;
    questionId: string;
    openAnswer?: string;
    selectedAnswers?: string[];
    timestamp?: string;
    clientType?: ClientType;
}

export interface ParticipantAnswers {
    participantId?: string;
    isFinalized: boolean;
    answers: QuestionAnswer[];
}
